<template>
  <div class="content-8">
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">总和路珠</span>
        </div>
      </div>
      <div class="content-8__titlebar__right">
        <DateFilterTab v-model="selectDate" />
      </div>
    </div>
    <TrendExplanation />
    <div class="content-8__controlbar">
      <RadioButtons v-if="is11x5" v-model="filterType" title="筛选路珠" :buttons="hmBtns" />
    </div>

    <div v-if="data.length > 0 && !isLoading" class="content-8__content">
      <div v-for="(group, index) in filterData" :key="index" class="luzhutable">
        <div class="luzhutable__head">
          <div class="luzhutable__head__left">
            <div class="luzhutable-group">
              <span class="head-text">连续出现</span>
              <div class="inputbox">
                <input :ref="`${group.field}-${group.ruleType}-count`" class="inputbox__input" type="number" min="1" value="0">
              </div>
              <span class="head-text">次以上</span>
              <div class="selectbox">
                <select :ref="`${group.field}-${group.ruleType}-type`" class="selectbox__select">
                  <template v-for="(total, totalIndex) in luZhuSortMapping">
                    <option
                      v-if="group.totals[total.key] || isHeZero(total.key, group.ruleType, group.field)"
                      :key="`sort-${totalIndex}`"
                      :value="total.key"
                    >
                      <template v-if="group.field !== 'allmantissa'"> {{ total.key | itemName }} </template>
                      <template v-else> {{ total.key | mantissaItemName }} </template>
                    </option>
                  </template>
                </select>
              </div>
              <a class="button-primary active" @click.prevent="handleSortLight(`${group.field}-${group.ruleType}`)">
                <span class="button-primary__text">确定</span>
              </a>
            </div>
            <div class="luzhutable-group">
              <span class="head-text">出现的次数:</span>
              <span :ref="`${group.field}-${group.ruleType}-value`" class="head-text">{{ getCount(`${group.field}-${group.ruleType}`) }}</span>
            </div>
          </div>
          <div class="luzhutable__head__right">
            <div class="luzhutable-group">
              <span class="head-text">今日累计:</span>
              <template v-for="(mappingItem, sortIndex) in luZhuSortMapping">
                <span
                  v-if="group.totals[mappingItem.key]"
                  :key="`sort-${sortIndex}`"
                >
                  <template v-if="group.field !== 'allmantissa'">{{ mappingItem.key | itemName }}({{ group.totals[mappingItem.key] }}) </template>
                  <template v-else>{{ mappingItem.key | mantissaItemName }}({{ group.totals[mappingItem.key] }})</template>
                </span>
                <span
                  v-else-if="isHeZero(mappingItem.key, group.ruleType, group.field)"
                  :key="`sort-${sortIndex}`"
                >
                  和(0)
                </span>
              </template>
            </div>
            <div class="luzhutable-group">
              <span class="head-text red">{{ typeFilter(group.field, group.ruleType) }}</span>
              <span class="head-text red">最新↓</span>
            </div>
          </div>
        </div>
        <div class="luzhutable-scroll">
          <div :ref="`${group.field}-${group.ruleType}`" class="luzhutable__content">
            <div
              v-for="(point, pointIndex) in group.roadBeads"
              :key="`point-${pointIndex}`"
              class="luzhutable__content__item"
              :class="handleHighlight(`${group.field}-${group.ruleType}`, point)"
            >
              <div class="textbox">
                <div
                  v-for="(pointItem, pointItemIndex) in point"
                  :key="`point-item-${pointItemIndex}`"
                  class="textbox__item"
                  :class="textColor(pointItem)"
                >
                  <span class="textbox__item__text">{{ pointItem | itemName }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NoData v-if="data.length === 0 && !isLoading" />
    <Loading v-if="isLoading" />
  </div>
</template>

<script>
import { getRoadBallCount_mobile } from '@/api/mobile/roadball'
import DateFilterTab from '@/components/web/pages/trend/DateFilterTab'
import TrendExplanation from '@/components/web/pages/trend/TrendExplanation/index'
import RadioButtons from '@/components/web/common/RadioButtons'
import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'

export default {
  name: 'ZongHeLuJhu',
  components: {
    DateFilterTab,
    TrendExplanation,
    RadioButtons,
    Loading,
    NoData
  },
  filters: {
    itemName(value) {
      switch (value) {
        case 'daxiao_da':
          return '大'
        case 'daxiao_xiao':
          return '小'
        case 'daxiao_he':
        case 'danshuang_he':
          return '和'
        case 'danshuang_dan':
          return '单'
        case 'danshuang_shuang':
          return '双'
        default:
          console.log(value)
          console.error('错误球名称')
          return value
      }
    },
    // for 尾數狀況
    mantissaItemName(value) {
      switch (value) {
        case 'daxiao_da':
          return '尾大'
        case 'daxiao_xiao':
          return '尾小'
        case 'daxiao_he':
        case 'danshuang_he':
          return '尾和'
        case 'danshuang_dan':
          return '尾单'
        case 'danshuang_shuang':
          return '尾双'
        default:
          console.log(value)
          console.error('错误球名称')
          return value
      }
    }
  },
  data() {
    return {
      isLoading: true,
      data: [],
      filterType: 'zongHeDaXiao',
      hmBtns: [
        { name: '大小', val: 'zongHeDaXiao' },
        { name: '单双', val: 'zongHeDanShuang' }
      ],
      selectDate: '30',
      hightlightObj: {},
      luZhuSortMapping: [
        { key: 'daxiao_da', label: '大' },
        { key: 'daxiao_xiao', label: '小' },
        { key: 'danshuang_dan', label: '单' },
        { key: 'danshuang_shuang', label: '双' },
        { key: 'daxiao_he', label: '和' },
        { key: 'danshuang_he', label: '和' }
      ]
    }
  },
  computed: {
    isKL10() {
      // 幸運農場也是快樂十分
      return this.$route.params.lottery_code.includes('kl10') || this.$route.params.lottery_code.includes('xync')
    },
    is11x5() {
      return this.$route.params.lottery_code.includes('11x5')
    },
    isSSC() {
      return this.$route.params.lottery_code.includes('ssc')
    },
    isXY28() {
      return this.$route.params.lottery_code.includes('xy28')
    },
    isK3() {
      return this.$route.params.lottery_code.includes('k3')
    },
    filterData() {
      if (this.is11x5) {
        return this.data.filter(item => item.ruleType === this.filterType)
      } else {
        return this.data
      }
    }
  },
  watch: {
    selectDate(newValue) {
      this.getInfo(newValue)
    }
  },
  created() {
    this.getInfo('30')
  },
  methods: {
    async getInfo(query) {
      const form = {}
      if (/^\d{2}$/.test(query)) {
        form.count = query
      } else {
        form.date = query
      }
      this.isLoading = true
      const [data, error] = await getRoadBallCount_mobile({
        code: this.$route.params.lottery_code,
        rules: 'zongHeDaXiao,zongHeDanShuang',
        ...form
      })
      this.isLoading = false
      if (error) {
        console.error(`[error]:`, error)
        return
      }

      const hightLightInitObj = {}
      data.forEach((type) => {
        hightLightInitObj[`${type.field}-${type.ruleType}`] = ''
      })

      this.hightlightObj = hightLightInitObj

      // 一般彩過濾掉尾數 快樂十分過濾掉多餘的单双尾數
      if (this.isKL10) {
        this.data = data.filter(row => (row.field !== 'allmantissa' || row.ruleType !== 'zongHeDanShuang')).sort((a, b) => {
          return a.ruleType > b.ruleType ? -1 : 1
        })
      } else {
        this.data = data.filter(row => (row.field !== 'allmantissa')).sort((a, b) => {
          return a.ruleType > b.ruleType ? -1 : 1
        })
      }
    },
    textColor(val) {
      // 球区分颜色
      switch (val) {
        case 'daxiao_da':
        case 'danshuang_shuang':
        case 'yanse_hong':
        case 'longHu_long':
          return 'red'
        case 'yanse_lan':
          return 'blue'
        case 'yanse_lyu':
          return 'green'
        default:
          return ''
      }
    },
    handleHighlight(ball, point) {
      if (
        point.length >= Number(this.hightlightObj[ball].split('-')[0]) &&
        point[0] === this.hightlightObj[ball].split('-')[1]
      ) {
        return 'hightlight'
      }
    },
    // 計算 Hightlight 數量
    getCount(name) {
      this.$nextTick(() => {
        if (this.$refs[name]) {
          const childrenNodes = Array.from(this.$refs[name][0].children)
          const highLightItems = childrenNodes.filter((node) => {
            return node.className.includes('hightlight')
          })
          this.$refs[`${name}-value`][0].innerHTML = highLightItems.length
        } else {
          return 0
        }
      })
    },
    typeFilter(field, type) {
      if (field.includes('mantissa')) {
        switch (type) {
          case 'zongHeDaXiao':
            return '总和尾大尾小'
          case 'zongHeDanShuang' :
            return '总和尾单尾双'
          default:
            console.log(type)
            console.error('错误分组名称')
            return type
        }
      }

      // 快樂十分跟一般彩種不一樣
      switch (type) {
        case 'zongHeDaXiao':
          return '总和大小'
        case 'zongHeDanShuang' :
          return '总和单双'
        default:
          console.log(type)
          console.error('错误分组名称')
          return type
      }
    },
    handleSortLight(ball) {
      const count = `${ball}-count`
      const type = `${ball}-type`
      this.hightlightObj = Object.assign(this.hightlightObj, {
        [ball]: `${this.$refs[count][0].value}-${this.$refs[type][0].value}`
      })
    },
    // 判斷是否要顯示 和(0)
    isHeZero(openType, ruleType, field) {
      // 快3有單雙和
      if (openType === 'danshuang_he' && ruleType === 'zongHeDanShuang' && field === 'all' && this.isK3) {
        return true
      }

      // 大小和
      if (openType === 'daxiao_he' && ruleType === 'zongHeDaXiao' && field === 'all' && !this.isSSC && !this.isXY28) {
        return true
      }

      return false
    }
  }
}
</script>

<style lang="scss">

</style>
